import styled, { css } from 'styled-components';

import { theme } from '@/theme';

import { Flex } from '../Flex';
import { NextImageWithLoader } from '../NextImageWithLoader';
import { Typography } from '../Typography';
import type { SizeType, StyleType } from './types';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(4)};
  margin-top: ${theme.spacing(2)};

  ${theme.media.md.up} {
    flex-direction: row;
    margin-top: ${theme.spacing(3)};
  }
`;

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
  padding-bottom: ${theme.spacing(1)};
`;

export const WatchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
  align-items: center;

  ${theme.media.md.up} {
    gap: ${theme.spacing(4)};
  }
`;

export const WatchImageContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const WatchImage = styled(NextImageWithLoader)`
  width: 343px;
  height: 343px;
  min-height: 343px;
  min-width: 343px;

  ${theme.media.md.up} {
    width: 400px;
    height: 400px;
    min-height: 400px;
    min-width: 400px;
  }
`;

export const EngravingOverlay = styled.div<{
  $sizeSelected: SizeType;
  $styleSelected: StyleType;
}>`
  position: absolute;
  color: ${theme.colors.engravingGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;
  text-shadow:
    -0.3px 0px 0px #4c4c4c,
    0px 0.3px 0 #ffffff;
  font-family: ${({ $styleSelected, theme }) =>
    $styleSelected === 'Block'
      ? theme.fontFamilies.engravingBlock
      : theme.fontFamilies.engravingCursive};
  font-size: ${({ $sizeSelected, $styleSelected, theme }) =>
    $sizeSelected === 'M'
      ? $styleSelected === 'Block'
        ? theme.fontSizes.p0
        : theme.fontSizes.p1
      : $styleSelected === 'Block'
        ? theme.fontSizes.h5
        : theme.fontSizes.p0};
`;

export const WatchName = styled.div`
  font-family: ${theme.fontFamilies.italianPlate};
  font-size: ${theme.fontSizes.h4};
  font-weight: ${theme.fontWeights.semibold};
  line-height: ${theme.lineHeights.h4};
  text-align: center;
  text-transform: uppercase;
`;
export const Text = styled(Typography)`
  text-align: center;

  ${theme.media.md.up} {
    text-align: left;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${theme.space.s100};
`;

export const SectionWrapper = styled(Flex)`
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: center;
  align-items: center;

  ${theme.media.md.up} {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const OptionSectionWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  width: 100%;

  ${theme.media.md.up} {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const OptionSecondaryRow = styled(SectionWrapper)`
  width: 100%;

  ${theme.media.md.up} {
    width: auto;
  }
`;

export const StyleButton = styled.button<{
  $selected: boolean;
  $size?: 'small' | 'medium';
  $style?: StyleType;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => ($size === 'small' ? '40px' : '128px')};
  height: 40px;
  ${({ $selected, $style, theme }) => css`
    background-color: ${$selected
      ? theme.colors.primaryBlue
      : theme.colors.secondaryLightGrey};
    color: ${$selected
      ? theme.colors.secondaryLightGrey
      : theme.colors.primaryBlue};
    font-family: ${$style === 'Block'
      ? theme.fontFamilies.engravingBlock
      : $style === 'Cursive'
        ? theme.fontFamilies.engravingCursive
        : theme.fontFamilies.openSans};
    ${!$style && `font-weight: ${theme.fontWeights.bold};`};
    ${$style === 'Block' && 'text-transform: uppercase;'};
  `}
`;

export const SelectSizeButton = styled.button`
  color: inherit;
  font: inherit;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
`;

export const CloseIconWrapper = styled.div`
  &&& {
    display: flex;
    position: absolute;
    min-width: 24px;
    right: 0;
    top: 27px;
    cursor: pointer;

    & svg {
      height: 24px;
      width: 24px;
    }
    ${theme.media.md.up} {
      right: ${theme.spacing(2)};
    }
  }
`;
